import React, { Fragment } from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Icon, Typography } from '@ui';
import { Card, Form } from 'antd';
import { FIELD_NAMES } from '../constants';
import SectionHeader from '../SectionHeader';
import Settings from './components/Settings';

const CustomizeUTM = ({ style }) => {
    const form = Form.useFormInstance();
    const isDropDownSettingsVisible = Form.useWatch(FIELD_NAMES.CUSTOMIZE_UTM, form);

    return (
        <Card data-e2e='tracking_customize-utms_section' style={style}>
            <SectionHeader
                icon={<Icon.KlicklyPixelHandLogo />}
                title='Customize Klickly UTMs'
                fieldName={FIELD_NAMES.CUSTOMIZE_UTM}
                titleE2e='tracking_customize-utms_title'
                toggleE2e='tracking_customize-utms_toggle'
            />
            {isDropDownSettingsVisible && (
                <Fragment>
                    <Typography.Text
                        data-e2e='tracking_customize-utms_description'
                        type='body2'
                        color={COLORS.$gray60Black}
                        style={BOTTOM_INDENTS.M}
                    >
                        Customize your Source, Medium, Campaign, and Term URL parameters.
                    </Typography.Text>
                    <Settings />
                </Fragment>
            )}
        </Card>
    );
};

export default CustomizeUTM;
